export default {
  airtableEnv: 'Staging',
  company: 'focus',
  project: 'demo',
  env: 'staging',
  apiUrl: 'https://us-central1-learn-67acf.cloudfunctions.net'
};
